import { Injectable } from '@angular/core';


@Injectable()
export class UserLanguageService {
  getCountryLanguages() {
    let lstlanuage = new LanguageListComponent('Hindi');
    return lstlanuage.CountryList();
  }

  constructor() {}
}
export class LanguageListComponent {
  selectedCountry: string;
  countries = [new Language('en', 'English'), new Language('es', 'Español')];
  CountryList() {
    return this.countries;
  }

  constructor(message: string) {
    this.selectedCountry = message;
  }
}

export class Language {
  constructor(public id: string, public name: string) {}
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/commonservice/commonlangservice.service.ts